import React, {useState} from "react";
import AuthService from "../../services/auth.service";
import "./style.css";

export default function Navbar({currentUser, setCurrentUser}) {
    const [showDropdown, setShowDropdown] = useState(false);
    const logOut = async () => {
        try {
            await AuthService.logout();
            setCurrentUser(undefined);
            setShowDropdown(false);
        } catch { /* Keep the existing session visible when logout fails. */ }
    };
    return <header className="navbar catalog-nav">
        <a href="/" className="catalog-brand">ПодборКниг</a>
        <nav className="catalog-nav-links" aria-label="Основная навигация">
            <a href="/">Каталог</a>
            <a href="/blog">Новости</a>
            <a href="/subscriptions">Мои подписки</a>
            {currentUser ? <div className="catalog-account">
                <button type="button" className="catalog-account-button" aria-expanded={showDropdown}
                        aria-controls="account-menu" onClick={() => setShowDropdown(!showDropdown)}>Аккаунт</button>
                {showDropdown && <div id="account-menu" className="catalog-account-menu">
                    <a href="/cabinet">Личный кабинет</a>
                    <button type="button" onClick={logOut}>Выйти</button>
                </div>}
            </div> : <a href="/login">Войти</a>}
        </nav>
    </header>;
}
